import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Select,
  Row,
  Col,
  Button,
  Divider,
  Space,
} from "antd";
import dayjs from "dayjs";

const { Option } = Select;
const titleOptions = ["Mr", "Ms", "Mrs"];

const calculateAge = (birthDate) => {
  if (!birthDate || !dayjs(birthDate).isValid()) return "";
  const today = dayjs();
  return today.diff(dayjs(birthDate), "year");
};

const EditPassengersModal = ({ visible, passengers, onSave, onCancel }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        passengers: passengers.map((p) => ({
          ...p,
          birth_date: dayjs(p.birth_date),
        })),
      });
    }
  }, [visible, passengers, form]);

  const handleBirthDateChange = (date, index) => {
    const age = calculateAge(date);
    const currentValues = form.getFieldValue("passengers");
    currentValues[index].age = age;
    currentValues[index].birth_date = date;
    form.setFieldsValue({ passengers: currentValues });
  };

  const handleOk = () => {
    form.validateFields().then((values) => {
      const formatted = values.passengers.map((p) => ({
        ...p,
        birth_date: p.birth_date.format("YYYY-MM-DD"),
      }));
      onSave(formatted);
    });
  };

  return (
    <Modal
      open={visible}
      title="Edit Passengers"
      onOk={handleOk}
      onCancel={onCancel}
      width={900}
      okText="Save"
    >
      <Form form={form} layout="vertical">
        <Form.List name="passengers">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, idx) => (
                <div
                  key={key}
                  style={{
                    marginBottom: 32,
                    padding: 16,
                    border: "1px solid #eee",
                    borderRadius: 8,
                    backgroundColor: "#fafafa",
                    position: "relative",
                  }}
                >
                  <Space
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 8,
                    }}
                  >
                    <h3 style={{ margin: 0 }}>Passenger #{idx + 1}</h3>
                  </Space>

                  <Row gutter={16}>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, "title"]}
                        label="Title"
                        rules={[{ required: true }]}
                      >
                        <Select placeholder="Select title">
                          {titleOptions.map((t) => (
                            <Option key={t} value={t}>
                              {t}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, "first_name"]}
                        label="First Name"
                        rules={[{ required: true }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, "middle_name"]}
                        label="Middle Name"
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        {...restField}
                        name={[name, "last_name"]}
                        label="Last Name"
                        rules={[{ required: true }]}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        {...restField}
                        name={[name, "birth_date"]}
                        label="Birth Date"
                        rules={[{ required: true }]}
                      >
                        <DatePicker
                          style={{ width: "100%" }}
                          onChange={(date) => handleBirthDateChange(date, name)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        {...restField}
                        name={[name, "age"]}
                        label="Age"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              ))}
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};

export default EditPassengersModal;
